/* Color configurations */
const colorBackgroundLocation = 'rgb(233, 235, 228)';
const colorBackgroundLocationOwn = 'rgb(228, 235, 233)';
const colorBackgroundSearchMetrics = 'rgb(228, 228, 235)';
const colorBackgroundPerformance = 'rgb(240, 240, 240)';
const colorBackgroundNextPlaces = 'rgb(228, 240, 228)';

const colorBackgroundError = 'rgb(235, 213, 218)';

const colorCurrentPosition = 'rgb(24, 13, 175)';
const colorCurrentPositionDisabled = 'rgb(180, 180, 180)';

/*
 * Export functions.
 */
export {
    colorBackgroundLocation,
    colorBackgroundLocationOwn,
    colorBackgroundSearchMetrics,
    colorBackgroundPerformance,
    colorBackgroundNextPlaces,
    colorBackgroundError,
    colorCurrentPosition,
    colorCurrentPositionDisabled
}
